import { Chip } from '../primitives/chip.js'
import type { ChipProps } from '../primitives/chip.js'
import { getColorCSS } from '../color/color.js'
import { hashColorName } from '../color/hash-color.js'

export interface TagProps extends ChipProps {
  label: string
  variant?: 'filled' | 'outlined'
}

export const Tag = ({ label, style, ...restProps }: TagProps) => {
  const bgColor = getColorCSS(hashColorName(label))
  return (
    <Chip
      label={label}
      style={{
        marginLeft: 0,
        backgroundColor: bgColor,
        color: '#fff',
        ...style,
      }}
      {...restProps}
    />
  )
}
